import React from 'react';
import { EcsDevice } from 'shared/models';
import { ElevatorDevice } from '../elevatorDevice/ElevatorDevice';

export type Props = {
    devices: EcsDevice[];
};

export const ElevatorDeviceList = ({ devices }: Props) => {
    return (
        <div className="elevator-device-list">
            { devices.map(d =>
                <ElevatorDevice
                    key={ d.deviceId }
                    device={ d }
                />
            ) }
        </div>
    );
};
